"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduce;
exports.getAnnouncementChangeList = getAnnouncementChangeList;
exports.getAnnouncementFilters = getAnnouncementFilters;
exports.getAnnouncements = getAnnouncements;
exports.getAnnouncementsLoading = getAnnouncementsLoading;
exports.getFilteredAnnouncement = getFilteredAnnouncement;
exports.getLastAnnouncementSeenTimeStamp = getLastAnnouncementSeenTimeStamp;
exports.getLastSeenTimeStamp = getLastSeenTimeStamp;
exports.getUserEntitlements = getUserEntitlements;
exports.hasUnseenAnnouncements = hasUnseenAnnouncements;
exports.hasUnseenAnnouncementsPresent = hasUnseenAnnouncementsPresent;
var types = _interopRequireWildcard(require("../actions/actionTypes"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

const initialState = {
  AnnouncementsList: [],
  lastSeenTimeStamp: 1555714260,
  lastAnnouncementSeenTimeStamp: 1555714260,
  isLoading: false,
  filters: {
    metadata: [{
      label: 'Maintenance',
      key: 'MAINTENANCE'
    }, {
      label: 'Major issue',
      key: 'MAJOR'
    }, {
      label: 'Minor issue',
      key: 'MINOR'
    }]
  },
  changeList: [],
  userEntitlements: []
};
function reduce() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const payload = action.payload;
  const userEntitlementsPayload = action.userEntitlementsPayload;
  switch (action.type) {
    case types.ACTIVE_IMS_ORG_CHANGED:
      return {
        ...state,
        AnnouncementsList: []
      };
    //On announcements fetched
    case types.ANNOUNCEMENTS_FETCHED:
      return {
        ...state,
        isLoading: false,
        AnnouncementsList: payload
      };
    case types.ANNOUNCEMENTS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case types.ANNOUNCEMENTS_FAILURE:
      return {
        ...state,
        isLoading: false
      };
    //Resetting last seen time stamp
    case types.SET_LAST_ANNOUNCEMENT_TS:
      return {
        ...state,
        lastSeenTimeStamp: payload.lastSeenTimestamp
      };
    case types.SET_LAST_SEEN_ANNOUNCEMENT_TS:
      /*
      * lastAnnouncementSeenTimeStamp is for showing New and Earlier sections
      * as current behaviour is on opening flyout, remove the blue dot from bell icon
      * in unified-shell and tab in widget but still group the notifications into new and early
      */
      return {
        ...state,
        lastAnnouncementSeenTimeStamp: payload
      };
    //on filtered announcement fetched
    case types.FILTERED_ANNOUNCEMENT_FETCHED:
      return {
        ...state,
        changeList: payload.changeList
      };
    case types.FETCHED_USER_ENTITLEMENTS:
      return {
        ...state,
        userEntitlements: userEntitlementsPayload
      };
    //default
    default:
      return state;
  }
}

/**
 * Get last seen time stamp value in epocseconds.
 * @param {JSON} state - Reducer state.
 * @returns {AnnouncementType} - Returns AnnouncementList.
 */
function getAnnouncements(state) {
  return state.announcements.AnnouncementsList;
}
function getAnnouncementsLoading(state) {
  return state.announcements.isLoading;
}

/**
 * Get last seen time stamp value in epocseconds.
 * @param {JSON} state - Reducer state.
 * @returns {number} - Returns timestamp.
 */
function getLastSeenTimeStamp(state) {
  return state.announcements.lastSeenTimeStamp;
}
function getLastAnnouncementSeenTimeStamp(state) {
  return state.announcements.lastAnnouncementSeenTimeStamp;
}

/**
 * Get Announcements Filter list.
 * @param {JSON} state - Reducer State.
 * @returns {AnnouncementsFilterType} -Returns filter List.
 */
function getAnnouncementFilters(state) {
  return state.announcements.filters;
}
function getUserEntitlements(state) {
  return state.announcements.userEntitlements;
}
function getAnnouncementChangeList(state) {
  return state.announcements.changeList;
}
function hasUnseenAnnouncements(state) {
  if (state.announcements.AnnouncementsList && state.announcements.AnnouncementsList.length > 0) {
    return state.announcements.AnnouncementsList[0].createTimeStamp > state.announcements.lastSeenTimeStamp;
  }
  return false;
}
function hasUnseenAnnouncementsPresent(state) {
  if (state.announcements.AnnouncementsList && state.announcements.AnnouncementsList.length > 0) {
    return state.announcements.AnnouncementsList[0].createTimeStamp > state.announcements.lastAnnouncementSeenTimeStamp;
  }
  return false;
}

/*returns filtered announment based on selected filters*/
function getFilteredAnnouncement(state) {
  let key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'eventType';
  //when all the filters are deselected, changelist is empty
  if ((0, _isEmpty.default)(state.announcements.changeList)) {
    return state.announcements.AnnouncementsList;
  }
  if (!(0, _isEmpty.default)(state.announcements.AnnouncementsList)) {
    //filters all elements passing the criteria
    return state.announcements.AnnouncementsList && state.announcements.AnnouncementsList.filter(announcement =>
    // dynamically validate all filter criteria
    state.announcements.changeList.some(item => {
      // All maintenance events should just show up regardless of eventtype
      if (item.key === 'MAINTENANCE') {
        return announcement.isMaintenance;
      }
      return item.key === announcement[key];
    }));
  }
  return [];
}